import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { MyInternalLink } from 'components/MyLink'
import { BackToPremiumsBreadcrumb } from 'containers/Premiums/components/BackToPremiumsBreadcrumb'
import { PaymentDetailsCard } from '../../components/PaymentDetailsCard/PaymentDetailsCard'
import { useQueryParams } from 'hooks/useQueryParams'
import { Component } from '@cms-max/medicare-api-sdk'

export const MakeAPaymentSuccessPage: FC = () => {
  const { t } = useTranslation('makeAPaymentSuccessPage')
  const queryParams = useQueryParams()
  const agencyTrackingId = queryParams.get('agencyTrackingId') || ''
  const tcsAppId = queryParams.get('tcsAppId') || ''

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
      printComponent={Component.Premiums}
      nav={<BackToPremiumsBreadcrumb />}

    >
      <div className='ds-l-container'>
        <Alert variation='success' className='ds-u-measure--wide'>
          {t('successMessage')}
        </Alert>
        {(agencyTrackingId && tcsAppId) && (
          <PaymentDetailsCard agencyTrackingId={agencyTrackingId} appId={tcsAppId} />
        )}
        <MyInternalLink to="/premiums" className="ds-c-button ds-c-button--alternate ds-c-button--solid ds-u-margin-top--5">
          {t('backToPremiumsButton')}
        </MyInternalLink>
      </div>
    </ContentLayout>
  )
}
